/**
 * Shared helpers used across multiple navigation guards.
 *
 * Store accessors live behind functions (not module-level constants) because
 * guards run before Pinia is fully installed at import time.
 */

import type { RouteLocationNormalized } from 'vue-router';

import useAuthStore from '@/stores/auth';

export const isUnguardedRoute = (route: RouteLocationNormalized): boolean =>
  route.meta?.unguarded === true;

export const isUserAuthenticated = (): boolean => {
  const authStore = useAuthStore();
  return authStore.isUserAuthenticated;
};
